import { render } from "./SetpasswordView.vue?vue&type=template&id=3f7c9d8d"
import script from "./SetpasswordView.vue?vue&type=script&lang=js"
export * from "./SetpasswordView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__